document.addEventListener("DOMContentLoaded", function () {
    const generateButton = document.getElementById("generate-image-button");
    const imageResult = document.getElementById("image-result");

    generateButton.addEventListener("click", function () {
        const text = document.getElementById("image-text").value.trim();
        const background = document.querySelector("input[name='background-id']:checked");

        if (!text || !background) {
            console.log("Please enter your message and select a background.");
            return;
        }

        const backgroundId = background.value;

        const formData = new FormData();
        formData.append("action", "generate_congratulation_image");
        formData.append("text", text);
        formData.append("background_id", backgroundId);
        formData.append("nonce", ajax_object.nonce);

        fetch(ajax_object.ajax_url, {
            method: "POST",
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("AJAX Response:", data);
                if (data.success) {
                    const imageUrl = data.data.image_url;

                    if (!imageUrl) {
                        console.log("Error: Image URL is undefined.");
                        return;
                    }

                    // Clear any previous content in the result area
                    imageResult.innerHTML = "";

                    // Create and display the image
                    const imgElement = document.createElement("img");
                    imgElement.src = imageUrl;
                    imgElement.alt = "Generated Greeting Card";
                    imgElement.style.maxWidth = "100%";
                    imgElement.style.height = "auto";

                    // Create buttons container
                    const buttonContainer = document.createElement("div");
                    buttonContainer.style.marginTop = "15px";
                    buttonContainer.style.display = "flex";
                    buttonContainer.style.gap = "10px";

                    // Facebook Messenger Share Button
                    const fbButton = document.createElement("button");
                    fbButton.textContent = "Kopīgojiet pakalpojumā Messenger";
                    fbButton.style.padding = "10px";
                    fbButton.style.background = "#0084FF";
                    fbButton.style.color = "#fff";
                    fbButton.style.border = "none";
                    fbButton.style.cursor = "pointer";
                    fbButton.onclick = function () {
                        const fbMessengerUrl = `https://www.facebook.com/dialog/send?app_id=123456789&link=${encodeURIComponent(imageUrl)}&redirect_uri=${encodeURIComponent(imageUrl)}`;
                        window.open(fbMessengerUrl, "_blank");
                    };

                    // WhatsApp Share Button (Only the Image URL)
                    const waButton = document.createElement("button");
                    waButton.textContent = "Kopīgojiet vietnē WhatsApp";
                    waButton.style.padding = "10px";
                    waButton.style.background = "#25D366";
                    waButton.style.color = "#fff";
                    waButton.style.border = "none";
                    waButton.style.cursor = "pointer";
                    waButton.onclick = function () {
                        const waShareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(imageUrl)}`;
                        window.open(waShareUrl, "_blank");
                    };

                    // Download Button
                    const downloadButton = document.createElement("button");
                    downloadButton.textContent = "Lejupielādēt attēlu";
                    downloadButton.style.padding = "10px";
                    downloadButton.style.background = "#ff9800";
                    downloadButton.style.color = "#fff";
                    downloadButton.style.border = "none";
                    downloadButton.style.cursor = "pointer";
                    downloadButton.onclick = function () {
                        const a = document.createElement("a");
                        a.href = imageUrl;
                        a.download = "apsveikuma-kartina.jpg"; // Updated filename
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };

                    // Append elements
                    buttonContainer.appendChild(fbButton);
                    buttonContainer.appendChild(waButton);
                    buttonContainer.appendChild(downloadButton);
                    imageResult.appendChild(imgElement);
                    imageResult.appendChild(buttonContainer);

                    console.log("Image generated successfully!");
                } else {
                    console.error("Server Error:", data);
                    console.log("Error: " + data.message);
                }
            })
            .catch((error) => {
                console.error("AJAX Error:", error);
                console.log("An unexpected error occurred.");
            });
    });

    document.querySelectorAll('.background-option').forEach(option => {
        option.addEventListener('click', () => {
            // Remove red border from all images
            document.querySelectorAll('.background-option img').forEach(img => {
                img.style.boxShadow = 'none';
            });

            // Add red border to the clicked image
            const img = option.querySelector('img');
            if (img) {
                img.style.boxShadow = '0px 0px 10px rgba(0,255,0,0.5)';
            }
        });
    });

});
